import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import * as LayoutActions from '@layout/store/layout.actions';
import * as CompaniesPageActions from '@modules/companies/store/companies-page.actions';
import { jobRefresh } from '@modules/job-page/store/job.actions';
import { Job } from '@shared/models';
import { JobsActionsUnion, JobsActionTypes } from './jobs.actions';

export interface JobsState extends EntityState<Job> {
  selectedId: number;
  loading: boolean;
}

export const jobsAdapter: EntityAdapter<Job> = createEntityAdapter<Job>({
  selectId: (job: Job) => job.id,
  sortComparer: false,
});

export const initialState: JobsState = jobsAdapter.getInitialState({
  selectedId: 0,
  loading: false,
});

// Delete 'any' type from action's type after migration to ngrx 8 version
export function jobsReducer(state = initialState, action: JobsActionsUnion | any): JobsState {
  switch (action.type) {
    case JobsActionTypes.GetSuccess:
      return jobsAdapter.upsertOne(action.payload, {
        ...state,
        loading: false,
      });

    case jobRefresh.type:
    case JobsActionTypes.Load:
      return {
        ...state,
        loading: true,
      };

    case JobsActionTypes.LoadSuccess:
    case LayoutActions.layoutHeaderLoadJobsSuccess.type:
    case CompaniesPageActions.companiesLoadJobsPerCompanySuccess.type: {
      return jobsAdapter.upsertMany(action.payload.content, {
        ...state,
        loading: false,
      });
    }

    case JobsActionTypes.SelectSuccess:
      return {
        ...state,
        selectedId: action.payload,
      };

    case JobsActionTypes.Update:
    case JobsActionTypes.StatusUpdate:
      return {
        ...state,
      };

    case JobsActionTypes.TeamMembersUpdateSuccess:
    case JobsActionTypes.UpdateSuccess:
    case JobsActionTypes.StatusUpdateSuccess:
      return {
        ...jobsAdapter.upsertOne(action.payload, state),
      };

    default:
      return state;
  }
}
